import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {APIResponse} from '@core/interfaces/system/system-common';
import {CurveCalibrationDetails} from '../../../pages/survival-analysis/api/pojo/curve-calibration-outputs.pojo';

export interface FilterOperatorOption {
    operatorLabel: string;
    filterOperator: FilterOperator;
    filterType: WebFilterType;
    fieldValue: any;
    fieldValues: any[];
}
//todo: need to confirm
export interface FilterOperator {}
//todo: need to confirm
export enum WebFilterType {
    None,
    Numeric,
    Date,
    Freetext,
    SingleSelect,
    MultiSelect,
}

export abstract class SurvivalAnalysisService {
    abstract getCurveCalibrationList(workflowItemId: number): Observable<DataSource>;

    abstract getAnalysisHistoryData(): Observable<DataSource>;

    abstract acceptCurve(workflowItemId: number, curveId: number, comment: string): Observable<APIResponse<any>>;

    abstract rejectCurve(workflowItemId: number, curveId: number, comment: string): Observable<APIResponse<any>>;

    abstract getCurveCalibrationData(
        workflowItemId: number,
        curveId: number,
    ): Observable<APIResponse<CurveCalibrationDetails>>;

    abstract getWorkflowDtoFull(workflowItemId: number): Observable<APIResponse<any>>;
}
